import { TRAVEL_OPTIONS_CONST } from '../actionConstants';
import { fromatRequest, getFilteredData } from '../../UtilityComponents/approvalRequestsUtils';

const INITIAL_STATE = {
	approvalData: {},
	apiloading: false,
	travelRequests: null,
	travelRequestForApproval: null,
	openRequests: null,
	openRequestsRequested: null,
	openRequestsApprover: null,
	filteredData: null
};

export default (state = INITIAL_STATE, action) => {
	if (!action) {
		return state;
	}

	switch (action.type) {
		case TRAVEL_OPTIONS_CONST.SET_TRAVEL_REQUESTS: {
			const { raisedByYou, forYouToApprove, openRequests, openRequestsRequested,
				openRequestsApprover } = fromatRequest(action.payload);
			return {
				...state,
				apiloading: false,
				travelRequests: raisedByYou,
				travelRequestForApproval: forYouToApprove,
				openRequests: openRequests,
				filteredData: openRequests,
				openRequestsRequested: openRequestsRequested,
				openRequestsApprover: openRequestsApprover
			};
		}
		case TRAVEL_OPTIONS_CONST.GET_API_CALL: {
			return {
				...state,
				apiloading: true
			};
		}
		case TRAVEL_OPTIONS_CONST.FILTER_REQUISITION_REQUESTS: {
			const { searchValue } = action.payload;
			const filteredResults = getFilteredData(state.openRequests, searchValue);
			return {
				...state,
				filteredData: filteredResults
			};
		}
		default:
			return state;
	}
};
